import { zodSortField } from "@/lib/utils";
import { z } from "zod";

export const deleteInternalAccountSchema = z.object({
  id: z.number(),
});

export const getInternalAccountsRequestSchema = z.object({
  sort: zodSortField(["name"]),
});

export const addInternalAccountSchema = z.object({
  name: z
    .string()
    .min(1, "Le nom est requis")
    .max(20, "Maximum de caractères atteint"),
  siret: z.string().min(14, "Le n° SIRET est incohérent"),
});

export const editInternalAccountSchema = z.object({
  id: z.number().optional(),
  name: z
    .string()
    .min(1, "Le nom est requis")
    .max(20, "Maximum de caractères atteint"),
  siret: z.string().min(14, "Le n° SIRET est incohérent"),
  isActive: z.boolean().default(true),
});
